import React, { useEffect, useRef, useState } from "react";
import OtpInput from "react-otp-input";
import { Alert, Button } from "antd";
import { BeatLoader } from "react-spinners";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Cookie from "js-cookie";
import { ArrowLeftOutlined } from "@ant-design/icons";

const EmailVerificationForm = ({ token, password, backHandler }) => {
  const resendTime = 10; // SECONDS
  const { http } = global.services;
  const [isLoading, setLoading] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(0);
  const [resendPreview, setResendPreview] = useState(false);
  const [sucessMessage, setsucessMessage] = useState("");
  const [otp, setOtp] = useState("");

  const [errors, setErrors] = useState({});
  const submitBtnRef = useRef();
  const history = useHistory();

  const onResend = async () => {
    setResendPreview(true);
    setSecondsRemaining(resendTime);
  };

  const submitHandler = async () => {
    let error = "";
    try {
      setLoading(true);
      let { data } = await http.post(`email-verification/${token}`, {
        otp: otp,
        password: password,
      });
      setLoading(false);
      toast.success(data.message);
      Cookie.set("role", "leads");
      Cookie.set("token_leads", data.token);
      Cookie.set("is_logged_once", JSON.stringify(data.is_logged_once));
      Cookie.set("email", data.email);
      if (data.token) localStorage.setItem("modal", 1);
      window.location.href = "/leads/";
    } catch (err) {
      setLoading(false);
      const { data, status } = err.response;
      if (status === 400) {
        error = { message: data.non_field_errors };
      }
    }

    setErrors(error || {});
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        submitBtnRef.current.click();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  useEffect(() => {
    let intervalId;
    if (secondsRemaining > 0) {
      intervalId = setInterval(() => {
        setSecondsRemaining((prevSeconds) => Math.max(0, prevSeconds - 1));
      }, 1000);
    }

    return () => clearInterval(intervalId); // Cleanup the interval when the component unmounts or secondsRemaining changes
  }, [secondsRemaining]); // This will only run when `secondsRemaining` changes

  useEffect(() => {
    const resendCode = async () => {
      if (resendPreview && secondsRemaining === 0) {
        setResendPreview(false);
        setsucessMessage("");
        try {
          await http.post(`resend-email-verification/${token}`);
          setsucessMessage("Code sent successfully.");
          setTimeout(() => {
            setsucessMessage("");
          }, 5000);
        } catch (err) {
          const { data, status } = err.response;
          if (status === 400) {
            const error = { message: data.non_field_errors };
            setErrors(error || {});
          }
        }
      }
    };

    resendCode();
  }, [secondsRemaining, resendPreview]);

  const formattedTime = `${Math.floor(secondsRemaining / 60)
    .toString()
    .padStart(2, "0")}:${secondsRemaining % 60 < 10 ? "0" : ""}${secondsRemaining % 60}`;

  return (
    <React.Fragment>
      {errors.message && (
        <Alert
          message={errors.message[0]}
          style={{ width: "100%", textAlign: "center" }}
          type="error"
        />
      )}
      {sucessMessage && (
        <Alert
          message={sucessMessage}
          style={{ width: "100%", textAlign: "center" }}
          type="success"
        />
      )}
      <OtpInput
        containerStyle="otp-container"
        inputStyle="otp-input"
        value={otp}
        onChange={setOtp}
        numInputs={6}
        renderSeparator={<span></span>}
        renderInput={(props) => <input {...props} />}
        inputType="tel"
        shouldAutoFocus={true}
      />
      <p className="resend-otp">
        {secondsRemaining > 0 ? (
          <>The code will be sent in {formattedTime}.</>
        ) : (
          <>
            Didn't recieve a code?{" "}
            <span onClick={onResend} className={`resend-btn`}>
              Resend
            </span>
          </>
        )}
      </p>
      <Button
        className="submit-btn"
        type="primary"
        onClick={submitHandler}
        ref={submitBtnRef}
      >
        {isLoading ? <BeatLoader color="#fff" size={8} /> : "Confirm & Proceed"}
      </Button>
      <div className="auth-back-btn-wrapper">
        <button type="button" className="auth-back-btn" onClick={backHandler}>
          <ArrowLeftOutlined /> Back to Signup
        </button>
      </div>
    </React.Fragment>
  );
};

export default EmailVerificationForm;
